export class Failure<Context> {
    private constructor(
        private _message: string,
        private _context: Context,
    ) { }

    static withMessage(message: string): Failure<undefined> {
        return new Failure(message, undefined)
    }

    static withContext<C>(message: string, context: C): Failure<C> {
        return new Failure(message, context)
    }

    get message(): string {
        return this._message
    }

    get context(): Context {
        return this._context
    }
}

export function hasFailed<T, C>(value: T | Failure<C>): value is Failure<C> {
    return value instanceof Failure;
}